import styled from 'styled-components';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import _ from 'lodash';
import { useApiInfoContextValueHook } from '../../../../../../../contexts/ApiInfoContext';
import { SellertoolSignatureUtils } from '../../../../../../../utils/sellertool-signature-utils';
import { ReturnExchangesApi } from '../../../../../../../apis/ReturnExchangesApi';
import { useFetcher } from '../../../../fetcher/useFetcher';
import { CustomBackdropController } from '../../../../../../../components/backdrop/default/v1';
import { useEffect, useState } from 'react';
import { CustomDialog } from '../../../../../../../components/dialog/v1/CustomDialog';
import { CustomLabelInput } from '../../../../../../../components/input/CustomLabelInput';
import { customToast } from '../../../../../../../components/toast/custom-react-toastify/v1';
import { CustomDateUtils } from '../../../../../../../utils/CustomDateUtils';
import { ProductOptionsApi } from '../../../../../../../apis/ProductOptionsApi';
import { GlobalWegetProductOptionModal } from '../../../../../../../global-wegets/global-weget-product-option-modal';
import { CustomLabelTextarea } from '../../../../../../../components/textarea/CustomLabelTextarea';
import { v4 as uuidv4 } from 'uuid';
import { InventoryReleasesApi } from '../../../../../../../apis/InventoryReleasesApi';

const StyledTableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;

  button{
    background-color: #fff;
    color: #333;
    border-radius: 3px;
    border:none;
    height: 30px;
    padding: 0 10px;
    font-weight: 600;
    cursor: pointer;

    &.not-yet{
        border:1px solid var(--redColor1);
        color: var(--redColor1);
    }

    &.ok{
        border:1px solid var(--greenColor1);
        color: var(--greenColor1);
    }
  }
`

const StyledModalHeader = styled.div`
    padding: 10px;
`;

const StyledModalBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .label{
        font-size: 14px;
        font-weight: 600;
        color: #333;
    }

    .content{
        font-size: 14px;
        font-weight: 500;
        color: #333;
        padding-left: 5px;
        margin-top: 5px;
    }

    input{
        border-radius: 3px;
        border: 1px solid #e0e0e0;
    }
`;

const StyledModalFooter = styled.div`
    padding: 10px;

    button{
        border-radius: 3px;
        background-color: #333;
        color: #fff;
        font-weight: 600;
        border:none;
    }
`;

export function TdExchangeStockReflect({
    returnExchange
}) {
    const [stockReflectModalOpen, setStockReflectModalOpen] = useState(false);
    const [cancelStockReflectModalOpen, setCancelStockReflectModalOpen] = useState(false);

    return (
        <>
            {returnExchange?.returnExchangeType !== 'EXCHANGE' ?
                <StyledTableCell></StyledTableCell>
                :
                <StyledTableCell>
                    {returnExchange?.exchangeStockReflectedFlag ?

                        <CustomBlockButton
                            type='button'
                            className='ok'
                            onClick={(e) => { e.stopPropagation(); setCancelStockReflectModalOpen(true) }}
                        >
                            반영됨
                        </CustomBlockButton>
                        :
                        <CustomBlockButton
                            type='button'
                            className='not-yet'
                            onClick={(e) => { e.stopPropagation(); setStockReflectModalOpen(true) }}
                        >
                            미반영
                        </CustomBlockButton>
                    }
                </StyledTableCell>
            }

            {stockReflectModalOpen &&
                <StockReflectModal
                    open={stockReflectModalOpen}
                    onClose={() => setStockReflectModalOpen(false)}
                    returnExchange={returnExchange}
                />
            }

            {cancelStockReflectModalOpen &&
                <CancelStockReflectModal
                    open={cancelStockReflectModalOpen}
                    onClose={() => setCancelStockReflectModalOpen(false)}
                    returnExchange={returnExchange}
                />
            }
        </>
    );
}

function StockReflectModal({
    open,
    onClose,
    returnExchange,
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();

    const [productOption, setProductOption] = useState(null);
    const [memo, setMemo] = useState('교환 재배송 출고');

    useEffect(() => {
        handleReqFetchProductOptions();
    }, [returnExchange?.exchangeReleaseOptionCode]);

    const handleReqFetchProductOptions = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            optionCodes: [returnExchange?.exchangeReleaseOptionCode]
        }
        const response = await ProductOptionsApi().searchListByOptionCodes({
            headers: headers,
            body: body
        });

        if (response?.content && response?.content.length > 0) {
            setProductOption(response?.content[0]);
        }
    }

    const handleSubmit = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        let formDatas = [];

        if (productOption?.packageYn === 'y') {
            const response = await ProductOptionsApi().searchListByPackageOptionIds({
                headers: headers,
                body: {
                    packageOptionIds: [productOption?.id]
                }
            });

            if (response?.content && response?.content?.length === 1) {
                formDatas = response?.content[0]?.packageItems?.map(packageItem => {
                    const unit = returnExchange?.exchangeReleaseQuantity * packageItem?.unit;
                    return {
                        cid: null,
                        id: uuidv4(),
                        unit: unit,
                        memo: memo || '',
                        createdAt: null,
                        deletedFlag: false,
                        productOptionId: packageItem?.targetOptionId,
                        erpItemId: null,
                        returnExchangeId: returnExchange?._id,
                    }
                })
            }
        } else {
            formDatas.push({
                cid: null,
                id: uuidv4(),
                unit: returnExchange?.exchangeReleaseQuantity,
                memo: memo || '',
                createdAt: null,
                deletedFlag: false,
                productOptionId: productOption?.id,
                erpItemId: null,
                returnExchangeId: returnExchange?._id,
            })
        }

        const body = {
            formDatas: [...formDatas]
        }

        CustomBackdropController().showBackdrop();
        const response = await InventoryReleasesApi().createList({ headers: headers, body: body });

        if (response?.content) {
            fetcher.fetchReturnExchanges();
            onClose();
        }
        CustomBackdropController().hideBackdrop();
    }

    const disabledSubmit = !productOption || !productOption?.code || !productOption?.product?.name || !productOption?.name || (!returnExchange?.exchangeReleaseQuantity || returnExchange?.exchangeReleaseQuantity <= 0);

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledModalHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            교환재출고 재고반영
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </StyledModalHeader>
                <StyledModalBody>
                    {disabledSubmit ?
                        <>
                            <div>교환정보의 상품 매칭을 확인해 주세요.</div>
                        </>
                        :
                        <>
                            <div>
                                <div className='label'>교환상품 옵션코드</div>
                                <div className='content'>{productOption?.code || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>교환상품명</div>
                                <div className='content'>{productOption?.product?.name || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>교환옵션명</div>
                                <div className='content'>{productOption?.name || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>수량</div>
                                <div className='content'>{returnExchange?.exchangeReleaseQuantity || '-'}</div>
                            </div>
                            <div>
                                <CustomLabelInput>
                                    <CustomLabelInput.Input
                                        type='text'
                                        value={memo}
                                        onChange={(e) => setMemo(e.target.value)}
                                    />
                                    <CustomLabelInput.Label>메모</CustomLabelInput.Label>
                                </CustomLabelInput>
                            </div>
                        </>
                    }
                </StyledModalBody>
                <StyledModalFooter>
                    <CustomBlockButton
                        type='button'
                        disabled={disabledSubmit}
                        onClick={handleSubmit}
                    >
                        재고반영
                    </CustomBlockButton>
                </StyledModalFooter>
            </CustomDialog>
        </>
    );
}

function CancelStockReflectModal({
    open,
    onClose,
    returnExchange,
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();

    const handleSubmit = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            formDatas: [returnExchange?._id]
        }

        CustomBackdropController().showBackdrop();
        const response = await InventoryReleasesApi().cancelList({ headers: headers, body: body });

        if (response?.content) {
            fetcher.fetchReturnExchanges();
            onClose();
        }
        CustomBackdropController().hideBackdrop();
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledModalHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            교환재출고 재고반영 취소
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </StyledModalHeader>
                <StyledModalBody>
                    해당 교환 주문건의 재고반영을 취소합니다.
                </StyledModalBody>
                <StyledModalFooter>
                    <CustomBlockButton
                        type='button'
                        onClick={handleSubmit}
                    >
                        재고반영 취소
                    </CustomBlockButton>
                </StyledModalFooter>
            </CustomDialog>
        </>
    );
}